export enum L2OrderbookActionTypes {
  SNAPSHOT = 'snapshot',
  ERROR = 'error',
  UPDATE = 'update',
  RESET = 'reset',
  EMPTY_SELL_ORDERS = 'empty_sell_orders',
  UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB',
}
